import * as React from "react";

const ChevronDownSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M3.87156 6.99016L2.10156 8.77016L12.0016 18.6602L21.9016 8.76016L20.1316 6.99016L12.0016 15.1202L3.87156 6.99016Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronDownSmall);
